import { render, staticRenderFns } from "./CxrList.vue?vue&type=template&id=25d82fb6&scoped=true&"
import script from "./CxrList.vue?vue&type=script&lang=js&"
export * from "./CxrList.vue?vue&type=script&lang=js&"
import style0 from "./CxrList.vue?vue&type=style&index=0&id=25d82fb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d82fb6",
  null
  
)

export default component.exports